import { Model } from '../decorators/model.decorator';
import { Column } from '../decorators/column.decorator';
import { AccountVdmoServer } from './account_vdmo_server.model'
import { BaseModel } from './base.model';
import { Product } from './product.model'
import { ProductBookAuthor } from './product_book_author.model';
import { Publisher } from './publisher.model';
import { Measure } from './measure.model';

@Model('accountBook', ['accountBooks', 'myBooks'])
export class AccountBook extends BaseModel {
  @Column()
  isbn: string | undefined;
  @Column()
  product: Product | undefined;
  @Column()
  accountVdmoServer: AccountVdmoServer | undefined;
}
